"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freon = freon;
const uom_1 = require("uom");
const uom_2 = require("@genesys/uom");
const value_1 = require("./value");
function freon(cooling) {
    const category = cooling ? "Wet " : "Dry ";
    return [
        (0, value_1.createAmount)(category + "temperature", uom_1.Amount.create(28, uom_2.Units.Celsius), uom_2.Units.Celsius, uom_2.Units.Fahrenheit),
        (0, value_1.createAmount)(category + "humidity", uom_1.Amount.create(0, uom_2.Units.GramPerKilogram), uom_2.Units.GramPerKilogram, uom_2.Units.GrainPerPoundLb),
        (0, value_1.createAmount)(category + "pressure", uom_1.Amount.create(101325, uom_2.Units.Pascal), uom_2.Units.Pascal, uom_2.Units.PoundForcePerSquareInch),
        (0, value_1.createAmount)(category + "evaporation temperature", uom_1.Amount.create(8, uom_2.Units.Celsius), uom_2.Units.Celsius, uom_2.Units.Fahrenheit),
        (0, value_1.createAmount)(category + "condensing temperature", uom_1.Amount.create(50, uom_2.Units.Celsius), uom_2.Units.Celsius, uom_2.Units.Fahrenheit),
        (0, value_1.createAmount)(category + "sub cooling", uom_1.Amount.create(0, uom_2.Units.DeltaCelsius), uom_2.Units.DeltaCelsius, uom_2.Units.DeltaFahrenheit),
        (0, value_1.createAmount)(category + "super heat", uom_1.Amount.create(0, uom_2.Units.DeltaCelsius), uom_2.Units.DeltaCelsius, uom_2.Units.DeltaFahrenheit),
        (0, value_1.createText)(category + "freon", "R410a", [
            "R134",
            "R22",
            "R404a",
            "R407c",
            "R410a"
        ])
    ];
}
//# sourceMappingURL=freon.js.map